export const buildApiUrl = (path) => {
  if (!path) return "";
  try {
    new URL(path);
    return path;
  } catch {
    const base = process.env.NEXT_PUBLIC_API_URL || "";
    const sep = path.startsWith("/") ? "" : "/";
    return `${base}${sep}${path}`;
  }
};

// Helper function to ensure valid image URLs and proper error handling
export const getImageUrl = (path) => {
  if (!path) return null;

  try {
    // If it's already a full URL, return it
    new URL(path);
    return path;
  } catch {
    // If it's a relative path, prepend the API URL
    return buildApiUrl(path);
  }
};

// Helper function to validate image
export const validateImageUrl = async (url) => {
  try {
    const response = await fetch(url, { method: "HEAD" });
    return response.ok;
  } catch {
    return false;
  }
};

// Helper function to get proper image dimensions
export const getImageDimensions = (imageType = "default") => {
  const dimensions = {
    default: { width: 800, height: 600 },
    thumbnail: { width: 150, height: 150 },
    banner: { width: 1920, height: 1080 },
    profile: { width: 300, height: 300 },
  };

  return dimensions[imageType] || dimensions.default;
};
